export default __webpack_public_path__ + "static/media/logo.837490c6.svg";